import { render } from "./qualityInspection.vue?vue&type=template&id=79b3fe0b&scoped=true"
import script from "./qualityInspection.vue?vue&type=script&lang=js"
export * from "./qualityInspection.vue?vue&type=script&lang=js"

import "./qualityInspection.vue?vue&type=style&index=0&id=79b3fe0b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79b3fe0b"

export default script